import styled from '@emotion/styled';
import { Badge, Text, tokens, Button, Card, Link } from '@hotjar/hotsauce';
import { NotCapturingErrors } from './EmptyState/NotCapturingErrors';

import {
  RECORDING_TILE_HEIGHT,
  RECORDING_TILE_WIDTH,
} from '../../components/common/RecordingTile/styles';

const EMPTY_STATE_IMAGE_HEIGHT = '160px';

export const StyledRelevantRecordingsWrapper = styled.div`
  background: ${tokens.color.bg_info};
  padding: ${tokens.spacer.x4} 0;
  overflow-x: auto;

  @media (min-width: 992px) {
    margin: 0 -30px;
    padding: ${tokens.spacer.x4} 30px;
  }
`;

export const StyledRecordingsOverviewGrid = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${tokens.spacer.x3};
  list-style: none;
  padding: 0;

  @media ${tokens.breakpoint.maxWidth.xl} {
    grid-template-columns: 1fr;
  }
`;

export const StyledRelevantRecordingsHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledRelevantRecordingsHeaderTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${tokens.spacer.x1};
`;

export const StyledRelevantRecordingsHeaderButton = styled(Button)`
  display: none;

  @media ${tokens.breakpoint.maxWidth.xxl} {
    display: inline-block;
  }
`;

export const StyledRecordingTiles = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin: ${tokens.spacer.x2} 0;
  gap: ${tokens.spacer.x3};

  @media ${tokens.breakpoint.maxWidth.xxl} {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media ${tokens.breakpoint.maxWidth.xl} {
    grid-template-columns: 1fr;
  }
`;

export const StyledViewAllRelevantRecordingsTile = styled.div`
  ${tokens.text('subtitle2')};

  min-width: ${RECORDING_TILE_WIDTH}px;
  height: ${RECORDING_TILE_HEIGHT}px;

  display: flex;
  justify-content: center;
  align-items: center;

  color: ${tokens.color.primary_cta};
  background: ${tokens.color.white};
  border: 1px solid ${tokens.color.ui_border};
  border-radius: ${tokens.radius.m};

  cursor: pointer;

  &:hover {
    background: ${tokens.color.bg_active};
    border-color: ${tokens.color.ui_border_active};
  }

  @media ${tokens.breakpoint.maxWidth.xxl} {
    display: none;
  }
`;

export const StyledSegmentsHeader = styled(Text)`
  margin: ${tokens.spacer.x5} 0 ${tokens.spacer.x4pt5};
`;

export const StyledNotCapturingErrors = styled(NotCapturingErrors)`
  text-align: center;
`;

export const StyledHeader = styled.header`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 84px;
  padding: 0 ${tokens.spacer.x2};
  border-bottom: 1px solid ${tokens.color.ui_border_light};
`;

export const StyledHeaderTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-right: ${tokens.spacer.x1};
`;

export const StyledFullWidthOverviewWidget = styled.li`
  width: 100%;
`;

export const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const StyledLink = styled(Link)`
  ${tokens.text('header5')}
  ${tokens.transition('color')};

  color: ${tokens.color.text_default};
  text-align: left;
  margin-bottom: ${tokens.spacer.x1};
  text-decoration: none;

  :hover {
    color: ${tokens.color.link_alt};
    text-decoration: underline;
  }
`;

export const StyledText = styled(Text)`
  margin-bottom: ${tokens.spacer.x1};
`;

export const StyledOverriddenState = styled.div`
  padding: ${tokens.spacer.x2} 0;
`;

export const StyledHeaderEmptyState = styled(StyledHeader)`
  border-bottom: none;
`;

export const StyledEmptyStateIllustration = styled.div<{ image: string; color: string }>`
  margin-bottom: ${tokens.spacer.x2};
  text-align: center;
  background-image: url('${({ image }) => image}');
  background-color: ${({ color }) => color};
  background-position: center;
  background-repeat: no-repeat;
  background-size: auto ${EMPTY_STATE_IMAGE_HEIGHT};
  height: ${EMPTY_STATE_IMAGE_HEIGHT};
`;

export const StyledEmptyStateTextContainer = styled.div`
  margin: 0 ${tokens.spacer.x2} ${tokens.spacer.x2};
`;

/* Upsell
 *************/

export const StyledUpsellCard = styled(Card)`
  box-shadow: none;
  border-radius: ${tokens.radius.l};
  border: 1px solid ${tokens.color.ui_border_light};
  cursor: pointer;
`;

export const StyledUpsellIllustration = styled(StyledEmptyStateIllustration)<{
  image: string;
  color: string;
}>`
  margin-bottom: 0;
`;

export const StyledUpsellHeader = styled(StyledHeader)`
  border-bottom: none;
`;

export const StyledUpsellTitle = styled(Text)`
  display: flex;
  align-items: center;
  margin-bottom: ${tokens.spacer.x1};
`;

export const StyledUpsellBadge = styled(Badge)`
  margin-left: ${tokens.spacer.x2};
`;
